<template>
  <v-container>
      <h3 class="ml-3">Farms</h3>
        <v-toolbar flat style="background-color:white" height="30">
            <v-spacer></v-spacer>
            <v-btn rounded color="#48c074" to='/farms/create/admin' dark class="mt-3" style="text-decoration:none"><v-icon color="" left >mdi-plus</v-icon> <span style="">Add Farms</span></v-btn>
        </v-toolbar>
        <div class="container">
             <v-row class="mt-7">
            <v-col cols="12" sm="12" lg="6">
                <v-text-field
                    label="Search for farms..."
                    height="10"
                    :items="farms"
                    item-text="name"
                    item-value="name"
                    solo
                    dense flat 
                    class=""
                    prepend-inner-icon="mdi-magnify" background-color="#f5f3fc"
                  
                    @keyup="search($event)"
                    @change="search($event)"
                ></v-text-field>
        
            </v-col>
            <v-col cols="12" sm="12" lg="6">
                <v-autocomplete
                    label="Category"
                    height="10"
                    :items="categories"
                    solo
                    dense flat 
                    class=""
                    background-color="#f5f3fc"
                   
                    item-text="categoryName"
                    item-value="categoryName"
                    @change="GetFarmFilter()"
                    v-model="category"
                ></v-autocomplete>
            </v-col>
        </v-row>

        </div>
       
        <!-- <v-row class="ma-5">
            <v-col
                cols="12"
                sm="8"
                md="3"
                v-for="n in farms" :key="n.name"
            >
                <v-card  hover shaped @click="getFarmById()">
                    <v-img
                        class=""
                        height="150px"
                        src='data:image/jpeg;base64,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' 
                        >
                    </v-img>
                    
                    <v-card-text class="pb-0">
                        <h3 style="color:#033953">{{n.name}}</h3>
                    </v-card-text>
                    <v-card-subtitle class="black--text py-0">Duration: {{n.ownerName}}</v-card-subtitle>
                    <v-card-subtitle class="py-0">Registered: {{n.dateCreated}}</v-card-subtitle>
                    <v-card-text>
                        <v-rating
                            :value="n.businessRating"
                            color="amber"
                            dense
                            half-increments
                            readonly
                            size="14"
                            class="ma-2"
                        ></v-rating>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->
        <div class="container mt-n8">
            <div class="row">
             <div class="col-lg-3 mb-3"  v-for="n in Farms" :key="n.name">
                <div class="card">
                <div class="card-body card-product">
                    <div class="text-center">
                        <!-- <img width="200" height="200" :src="n.farm_img_url" /> -->
                        <v-img :src="getImageUrl(n.farm_img_url)"  height="173.95"></v-img>
                    </div>
                    <h5 class="card-title text-center mt-5">{{n.name}}</h5>
                    <h6 class="card-text mx-4 mt-5 text-color">Duration: <span style="font-weight: bold;">{{n.duration}}</span> </h6>
                    <h6 class="card-text mx-4 text-color mt-3">Cost: <span style="font-weight: bold;">&#8358;{{n.cost}}</span></h6>
                    <h6 class="card-text mx-4 text-color mt-3">ROI:  <span style="font-weight: bold;">{{n.roi}}%</span></h6>
                    <div class="text-center mt-5 mb-4">
                        <button class="btn btn-green"  @click="getFarmById($event, n._id)">View More</button>
                    </div> 
                </div>
                </div>
            </div>
            
            
            </div> 
        </div>
         <v-row justify="center" v-if="Farms.length===0">
            <h1 class="grey--text"><i>NO FARMS FOR DISPLAY</i></h1>
        </v-row>
       
  </v-container>
</template>

<script>
export default {
    data(){
        return{
             categories:['All','commodity', 'farm', 'poultry', ]
        }
    },
   created(){
        this.$store.dispatch("GetFarms")
        .then(()=>{
        })
        .catch(()=>{
        })

    },
    computed:{
     Farms(){
        let farm = this.$store.state.farm.farms
        if(farm.length>0){
                for(let j=0; j<farm.length; j++){
                  farm[j].cost = parseFloat(farm[j].cost).toFixed(2)
                  farm[j].cost = farm[j].cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  farm[j].units_avail = farm[j].units_avail.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                }
                
              }
              return farm
      },
    }, 
     methods:{
        search(event){
            let word=event.target.value
            this.$store.dispatch("GetFarmFilter", word )
            .then(()=>{
            })
            .catch(()=>{
            })
        },
        
        getImgUrl(pic){
            if(!pic || pic===null || pic===''){
                return '/noimage.png'
            }else{
                // let weblink = "http://localhost:8085/public/profinderFiles/";
                let weblink = "https://yellow-profinder.herokuapp.com/public/profinderFiles/";
                
                return weblink +pic;
            }
            
        },
        getFarmById(event, id){
            event.preventDefault()
             this.$store.dispatch("GetFarmsById", id)
            .then((success)=>{
                this.$router.push(`/farms/admin/${success.data._id}`)
            })
            .catch(()=>{
            })
           
        },
        getImageUrl(url){
            return url
        },
        GetFarmFilter(){
            if(this.category === "All"){
                 this.$store.dispatch("GetFarms")
                    .then(()=>{
                        //   cogoToast.success('Login successful!')
                    })
                    .catch(()=>{
                    })
            }else{
                this.$store.dispatch("GetFarmByFilter", {cat:this.category} )
                .then(()=>{
                })
                .catch(()=>{
                })
            }   
        },
           
    }
}
</script>

<style>
.btn-green{
    background: #48c074;
    border-radius: 38.5px;
    color: #fff;
    padding: 10px 25px;
    transition: all 0.5s ;
  }
  .btn-green:hover{
    background: #fff;
    box-shadow: 0px -2px 10px rgba(255, 255, 255, 0.14), 0px 4.5px 10px rgba(255, 255, 255, 0.14);
    color: #48c074;
    border: 1px solid #48c074;
  }
  .input-style{
    padding: 20px 20px;
  }
  .input-style:focus{
    border-color: rgba(50, 54, 67, 0.2);
    box-shadow: 0px 5px 30px rgba(50, 54, 67, 0.2);
    outline: 0 none;
}
.card{
    border: 0
}
.product {
    border:0;
    transition: all ease-in-out 0.6s;
}
.card-home{
	height: 250px;
}
.card-product{
	background-color:#fff;
	border-radius:5px;
	box-shadow: 0 5px 11px 0 rgba(0,0,0,0.18),0 4px 15px 0 rgba(0,0,0,0.15);
}
.product:hover{
    transform: scale(1.07);
    transition: all ease-in-out 0.6s;
}
</style>